import { DataKey, DataRecord, DataResponse } from '../../types';

const addColumnToDataResponse = (
    dataResponse: DataResponse,
    column: DataKey,
    getValue: (record: DataRecord) => number | string | null
): DataResponse => ({
    columns: [...dataResponse.columns, column],
    records: dataResponse.records.map((record) => [...record, getValue(record)]),
});

export default addColumnToDataResponse;
